<div class="d-flex gap-4 mb-3 flex-wrap">
  <ziro-collapsible-section-card
    [isSwitchHidden]="true"
    [removeExpandedClass]="true"
    [title]="'tkey;migrations.ring_central.call_queues.teams_mapping.settings.title'"
    [subtext]="'tkey;migrations.ring_central.call_queues.teams_mapping.settings.description'"
    [icon]="ZiroIcons.GEAR_COMPLEX"
    [class]="'col'"
    [isCollapsible]="false"
  >
    <ziro-text [fieldId]="'name'" [inlineLabel]="false"></ziro-text>
    <ziro-select [fieldId]="'language'" [inlineLabel]="false"></ziro-select>
    <ziro-select [fieldId]="'routingMethod'" [inlineLabel]="false"></ziro-select>
    <ziro-text [fieldId]="'agentAlertTime'" [inlineLabel]="false"></ziro-text>
    <ziro-checkbox [fieldId]="'presenceAwareRouting'"></ziro-checkbox>
    <ziro-checkbox [fieldId]="'allowOptOut'"></ziro-checkbox>
  </ziro-collapsible-section-card>

  <ziro-collapsible-section-card
    [isSwitchHidden]="true"
    [removeExpandedClass]="true"
    [title]="'tkey;teams_call_queue.resource_accounts.header'"
    [icon]="ZiroIcons.PHONE_LIST"
    [class]="'col'"
    [isCollapsible]="false"
  >
    <div class="card-body pt-4 pb-0 d-flex flex-column" data-automation="teams-mapping-resource-accounts">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <label class="card-title mb-0">{{ 'tkey;teams_call_queue.resource_accounts.header' | translate }}</label>
      </div>
      <ul class="list-style-type-none p-0">
        @for (resourceAccount of resourceAccountViews; track resourceAccount.guid) {
          <li>
            <div class="card mb-3 px-4 d-flex align-items-center flex-row justify-content-between">
              <div class="d-flex gap-2 py-2">
                <div class="d-flex align-items-center">
                  <span class="initials initials-letterspacing-2">
                    <strong>{{ getUserInitialsFromDisplayName(resourceAccount.displayName) }}</strong>
                  </span>
                </div>
                <div class="flex-grow-1 d-flex flex-column justify-content-center">
                  <p class="mb-0">
                    <strong>{{ resourceAccount.displayName }}</strong>
                    |
                    <span data-automation="upn">{{ resourceAccount.upn }}</span>
                  </p>
                  <p class="card-text">
                    <strong>{{ resourceAccount.lineUri | telephoneNumberFilter }}</strong>
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <button
                  data-automation="delete-resource-account"
                  [class]="'btn-close close-button'"
                  (click)="deleteResourceAccount(resourceAccount)"
                ></button>
              </div>
            </div>
          </li>
        }
      </ul>
      <div class="w-100" #resourceButton>
        <ziro-button
          [dataAutomation]="'teams-mapping-add-resource-account'"
          [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
          [label]="'tkey;teams_call_queue.resource_accounts.add.resource_account'"
          [icon]="ZiroIcons.PLUS"
          [isFullWidth]="true"
          [cssClass]="'mb-4'"
          (click)="resourceAccountsPopover.toggle($event)"
        ></ziro-button>
      </div>
    </div>
    <p-popover
      #resourceAccountsPopover
      [styleClass]="'resource-popover'"
      (onHide)="onPopoverClose(resourceAccountsInput)"
      (onShow)="onResourceAccountPopoverOpen()"
    >
      <div
        #resourceAccountsPopoverContainer
        class="p-4 fit-content"
        data-automation="teams-mapping-resource-account-search-popover"
      >
        <label class="w-100 typeahead-search input-group">
          <input
            #resourceAccountsInput
            [attr.data-automation]="'teams-mapping-resource-account-type-ahead'"
            [class]="'w-100 form-control'"
            [ngClass]="{
              pending: isSearching,
            }"
            [type]="'text'"
            [ngbTypeahead]="resourceAccountsSearch"
            [placeholder]="'tkey;teams_call_queue.resource_accounts.resource_search.placeholder' | translate"
            [focusFirst]="true"
            (selectItem)="addResourceAccount($event.item)"
            [resultFormatter]="resourceAccountFormatter"
            [resultTemplate]="resourceAccountResult"
            [popupClass]="'resource-accounts-custom-typeahead'"
          />
          @if (isSearching) {
            <i class="{{ ZiroIcons.SAVING }} icon-warning fa-sm"></i>
          }
        </label>
        <div class="small form-text text-muted mt-1">
          {{ 'tkey;teams_call_queue.resource_accounts.resource_search' | translate }}
        </div>
      </div>
    </p-popover>
  </ziro-collapsible-section-card>
</div>

<ng-template #resourceAccountResult let-r="result">
  @let isDisabled = isResourceAccountDisabled(r);
  <div
    class="option-div"
    [ngClass]="{ 'disabled-option': isDisabled }"
    [ngbTooltip]="resourceAccountResultTooltip"
    [disableTooltip]="!isDisabled"
    placement="top"
    tooltipClass="resource-account-typeahead-tooltip"
    [tooltipContext]="{ r }"
    (click)="preventClickOnDisabledOptions($event, r)"
  >
    <span>{{ r.userPrincipalName }}</span>
  </div>
</ng-template>
<ng-template #resourceAccountResultTooltip let-r="r">
  <span [innerHtml]="getOptionTooltip(r) | escapeHtml" [style]="tooltipStyles"></span>
</ng-template>
